/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Trips_Dialog_DescInputs */

const en_ui_trips_dialog_desc = /** @type {(inputs: Ui_Trips_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose which trip this session belongs to.`)
};

const de_ui_trips_dialog_desc = /** @type {(inputs: Ui_Trips_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle, zu welcher Tour diese Einheit gehört.`)
};

/**
* | output |
* | --- |
* | "Choose which trip this session belongs to." |
*
* @param {Ui_Trips_Dialog_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trips_dialog_desc = /** @type {((inputs?: Ui_Trips_Dialog_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trips_Dialog_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trips_dialog_desc(inputs)
	return de_ui_trips_dialog_desc(inputs)
});